import './css/app.scss';
import './ts/neto.js';
import './ts/slider';
import loadSprite from './ts/loadSprite';
import lazyLoad from './ts/lazyLoad';
import dropdown from './ts/dropdowns';
import lineMove from './ts/lineMove';
import descMenu from './ts/descMenu';
import calcHieght from './ts/calcHeight';
import popups from './ts/popups';
import mobMenu from './ts/mobMenu';
import accordian from './ts/accordian';
import sidebar from './ts/sidebar';
import dinamicSidebar from './ts/dinamicSidebar';
import stickyHeader from './ts/stickyHeader';
import dinamicLinks from './ts/dinamicLinks';
import scrollCart from './ts/cartline';
import enquirePopup from './ts/enquirePopup';
import dynamicQty from './ts/dynamicQty';



loadSprite.init();
lazyLoad.init();
dropdown.init();
lineMove.init();
descMenu.init();
calcHieght.init();
popups.init();
mobMenu.init();
accordian.init();
sidebar.init();
dinamicSidebar.init();
stickyHeader.init();
dinamicLinks.init();
scrollCart.init();
enquirePopup.init();
dynamicQty.init();







 








